import React, { Component } from 'react';
import { Box } from '../../../../common/components';
import { Col, Row } from 'react-bootstrap';
import { InfoLabel } from '../../../../common/components';
import './BrokerPrimaryContact.scss';

export default class BrokerPrimaryContact extends Component {
  render() {
    const { primaryContact } = this.props;

    return (
      <Box className="primary-contact-box">
        <Row>
          <Col sm={12}>
            <h3>Primary Contact</h3>
          </Col>
        </Row>

        <Row key={primaryContact.attributes.email}>
          <Col sm={6}>
            <InfoLabel
              value={primaryContact.attributes.full_name}
              label={'Name'}
              labelSize={2}
            />
          </Col>
          <Col sm={6}>
            <InfoLabel
              value={primaryContact.attributes.email}
              label={'Email'}
              labelSize={2}
            />
          </Col>
        </Row>
      </Box>
    );
  }
}
